<template>
  <Page
    :step="step"
    :desktop="desktop"
    :title="title"
    :message="message"
    :inputs="totalInputs"
    :finished="touchedInputs"
  >

    <transition-group name="fade">
      <Child
        v-for="(child, index) in names"
        :key="child.id"
        :index="index"
        :child="child.name"
        :show-titles="showTitles"
        @remove-child="removeChild"
        @update-child="updateChildIndexName"
        @increment-input="incrementInput"
      />
    </transition-group>

    <button
      class="btn cta default"
      @click="addAnotherChild"
      :disabled="!(totalInputs == touchedInputs)"
    >Add another child<i class="fa fa-user-plus"/></button>

    <p
      class="hint"
      v-if="discount"
    >
      Their first box will also be free (+ £1 delivery)
    </p>

    <p
      class="hint"
      v-else
    >
      Add another activity box for a sibling
    </p>

    <button
      class="success cta continue-button"
      @click="next">Continue<i class="fa fa-play"/></button>

  </Page>
</template>

<script>
import Page from '../library/page.vue'
import Child from '../library/child.vue'

export default {
  name: 'Children',
  components: {
    Page,
    Child
  },
  props: {
    step: {
      type: Number,
      default: 0
    },
    desktop: {
      type: Boolean,
      default: true
    },
    names: {
      type: Array,
      default: function () { return [] }
    },
    discount: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: 'Personalise your child\'s toucanBox',
      message: 'The box will be addressed to your child to make it extra special.',
      showTitles: false,
      totalInputs: 3,
      touchedInputs: 0,
      inputTimer: null
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.$events.$on('modify-order', (value) => {
        console.log('change title')
        this.title = 'Modify your order'
        this.message = 'Add or remove children from your order.'
      })
    })
  },
  watch: {
    names: function (newVal, oldVal) {
      this.totalInputs = 3 * newVal.length
    }
  },
  methods: {
    next: function (event) {
      this.$emit('next')
      this.$emit('update-signup-object')
    },
    incrementInput: function (event) {
      clearTimeout(this.inputTimer)
      this.inputTimer = setTimeout(() => {
        if (this.touchedInputs < this.totalInputs && !event.target.parentNode.classList.contains('valid')) {
          this.touchedInputs++
        }
        if (!event.target.parentNode.classList.contains('input-wrap')) {
          event.target.parentNode.parentNode.parentNode.classList.add('valid')
        } else {
          event.target.parentNode.classList.add('valid')
        }
      }, 300)
    },
    addAnotherChild: function (event) {
      if (!this.showTitles) {
        this.showTitles = true
      }
      this.$events.$emit('added-child', event)
    },
    updateChildIndexName: function (event) {
      this.$events.$emit('update-child', event)
    },
    removeChild: function (event) {
      this.$events.$emit('removed-child', event)
      setTimeout(() => {
        this.touchedInputs = this.totalInputs
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
// For small screens, move the continue button icon over to distribute space evenly
@media only screen and (max-width: 330px) {
  .btn.cta.default {
    padding-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/children.vue